function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Favourites");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Styleguide",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Buttons--Copy",
  transform: "translate(-679.000000, -200.000000)"
}, React.createElement("g", {
  id: "Black",
  transform: "translate(287.000000, 144.000000)"
}, React.createElement("g", {
  id: "Favourites",
  transform: "translate(392.000000, 56.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fillOpacity: 0,
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}), React.createElement("path", {
  d: "M4.97727273,1.5 C2.59313636,1.5 1,3.5516882 1,5.83513964 C1,7.97769904 2.16088636,9.82930388 3.58029545,11.2905794 C4.99970455,12.7518549 6.69354545,13.8351396 7.85586364,14.4637349 C7.94638636,14.5120884 8.05361364,14.5120884 8.14413636,14.4637349 C9.30661364,13.8351396 11.0002955,12.7518549 12.4197045,11.2905794 C13.8391136,9.82930388 15,7.97769904 15,5.83513964 C15,3.5516882 13.4068636,1.5 11.0227273,1.5 C9.61731818,1.5 8.68361364,2.25097957 8,3.26640267 C7.31638636,2.25097957 6.38268182,1.5 4.97727273,1.5 Z",
  id: "like-icon-copy",
  stroke: "#1E1F20",
  strokeWidth: 1.5
})))));

var SvgFavourites = function SvgFavourites(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFavourites, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/favourites.ecb92030.svg";
export { ForwardRef as ReactComponent };